const buttons = document.querySelectorAll<HTMLButtonElement>('[data-share-button]');

buttons.forEach((button) => {
  button.addEventListener('click', async () => {
    const url = button.dataset.shareUrl ?? window.location.href;
    const title = button.dataset.shareTitle ?? document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // User dismissed the share sheet — nothing to do.
      }
      return;
    }

    if (navigator.clipboard) {
      await navigator.clipboard.writeText(url);
    }
  });
});
